import { Outlet } from 'react-router';

import { DiscardDialogProvider } from '@sternum/web/components';

export function RoutesWrapper() {
  return (
    <>
      <DiscardDialogProvider />
      <Outlet />
    </>
  );
}
